interface Props {
  url: string;
  title?: string;
}

const Banner = ({ url, title }: Props) => {
  return <>{url && <img className="rounded-2" src={url} alt={title} />}</>;
};

export default Banner;
